import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Chip = _resolveComponent("Chip");
    return (_ctx.zeroChipFilter)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            flat: "",
            tile: "",
            class: _normalizeClass(["pay-type", _ctx.inline ? 'd-inline-flex' : 'd-flex'])
        }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payTypes, (payType, key) => {
                return (_openBlock(), _createBlock(_component_Chip, {
                    key: `payType-${key}`,
                    label: "",
                    small: "",
                    class: "pay-type__chip",
                    "brg-chip-color": payType.color,
                    title: _ctx.$t(payType.text),
                    text: _ctx.$t(_ctx.isFullText ? payType.text : payType.shortenText)
                }, null, 8 /* PROPS */, ["brg-chip-color", "title", "text"]));
            }), 128 /* KEYED_FRAGMENT */))
        ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true);
}
